<template>
  <div class="contair">
    <div class="content">
      <div class="logoImg">
        <img src="../../assets/images/logo.png" />
      </div>
      <div class="inputContair">
        <div class="titleText">
          <p>忘记密码</p>
          <!-- <p>天算 v2019.08.24</p> -->
        </div>
        <el-form :model="forgetForm" status-icon :rules="forgetRules" ref="forgetForm" label-width="100px" class="demo-forgetForm">
          <el-form-item prop="phone">
            <form>
              <el-input type="text" v-model.trim="forgetForm.phone" autocomplete="off" placeholder="输入原手机号"></el-input>
            </form>
            <i class="iconfont icon-shouji"></i>
          </el-form-item>
          <el-form-item prop="verificationCode" class="verificate">
            <form>
              <el-input type="text" v-model.trim="forgetForm.verificationCode" autocomplete="off" placeholder="验证码" class="codeBox"></el-input>
            </form>
            <i class="iconfont icon-iconfront-"></i>
            <div class="verificat" v-if="countdownClickDisabled" style="background-color: #C0C0C0;cursor: pointer;">
              <span class="message">{{verificationMsg}}</span>
            </div>
            <div class="verificat" @click="getVerificationCode" style="background-color: #55ACEE;cursor: pointer;"
              v-else>
              <span class="message">{{verificationMsg}}</span>
            </div>
          </el-form-item>
          <el-form-item prop="newPass">
            <el-input type="password" v-model.trim="forgetForm.newPass" autocomplete="off" placeholder="密码"></el-input>
            <i class="iconfont icon-mima"></i>
          </el-form-item>
          <el-form-item prop="checkNewPass">
            <el-input type="password" v-model.trim="forgetForm.checkNewPass" autocomplete="off" placeholder="确认密码"></el-input>
            <i class="iconfont icon-mima"></i>
          </el-form-item>
          <el-form-item class="register">
            <el-button type="primary" @click="submitForgetForm('forgetForm')" class="registerButton">修改密码</el-button>
          </el-form-item>
        </el-form>
        <div class="loginWay">
          <!-- <p @click="gotoLogin()">已有账号登入</p> -->
          <span>
            <router-link to="/userLogin" class="tologin">已有账号登入</router-link>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  export default ({
    name: 'forgetPass',
    components: {

    },
    data() {
      var checkPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(value))) {
          callback(new Error('8-16位字母或数字，且必须同时包含数字和字母'));
        }else {
          if (this.forgetForm.checkPass !== '') {
            this.$refs.forgetForm.validateField('checkNewPass');
          }
          callback();
        }
      };
      var checkPass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.forgetForm.newPass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var checkPhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号码'));
        } else if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error('手机号码有误，请重新填写'));
        } else {
          //校验手机号在本系统是否已注册
          this.validateInfo({
            "mobile": value,
            "validateMobile": true
          }, callback);
          // callback();
        }
      };
      var checkVerificationCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入验证码'));
        } else {
          if (this.countdownTime < 0) {
            callback(new Error('验证码超时'));
          } else {
            //校验验证码是否正确
            this.validateInfo({
              "verificationCode": value,
              "mobile": this.forgetForm.phone
            }, callback);
          }
        }
      };
      return {
        verificationMsg: '获取验证码',
        countdownTime: this.$store.state.defaultCountdownTime, //倒计时秒
        countdownClickDisabled: true, //验证码发送控制  false:可点击   true:不可点击
        forgetForm: {
          phone: '',
          verificationCode: '',
          newPass: '',
          checkNewPass: '',
        },
        forgetRules: {
          newPass: [{
            validator: checkPass,
            trigger: 'blur'
          }],
          checkNewPass: [{
            validator: checkPass2,
            trigger: 'blur'
          }],
          phone: [{
            validator: checkPhone,
            trigger: 'blur'
          }],
          verificationCode: [{
            validator: checkVerificationCode,
            trigger: 'blur'
          }]
        }
      }
    },
    methods: {
      submitForgetForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.forgetPassWord();
          } else {
            return false;
          }
          // if (valid) {
          //   alert('submit!');
          // } else {
          //   console.log('error submit!!');
          //   return false;
          // }
        });
      },
      //重置密码表单提交
      forgetPassWord() {
        let this_ = this;
        var data_ = {
          "password": this_.forgetForm.newPass, //新密码
          "mobile": this_.forgetForm.phone, //手机号码
          "verificationCode": this_.forgetForm.verificationCode ,//验证码
          "client": this_.$store.state.defaultClient,
          "clientSys": this_.$store.state.defaultClientSys,
          "systemcode":this_.$store.state.systemcode //系统编号
        };



        let paramdata = {};
        paramdata.url = '/jwt/user/resetPassWord';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            //修改成功 跳转登录页
            this_.$router.push('/userLogin');
          } else {
            this_.$message.error('修改密码失败原因:' + res.data.errmsg);
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      validateInfo(data_, callback) {
        let this_ = this;
        //判断传入json对象是否为空
        if (data_ === null || qs.stringify(data_) === "{}") {
          data_ = {
            "mobile": this_.forgetForm.phone
          }; //默认验证手机号码
        }
        let paramdata = {};
        paramdata.url = '/jwt/user/validateForgetPassWord';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            if (data_.validateMobile) {
              this_.countdownClickDisabled = false; //手机号码验证通过后允许点击发送验证码
            }
            callback();
          } else {
            let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
            callback(new Error(errmsg));
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      // 获取验证码
      getVerificationCode() {
        //控制不能重复请求
        if (this.countdownClickDisabled) return;
        this.countdownClickDisabled = true;
        let this_ = this;
        var data_ = {
          "systemcode": this.$store.state.systemcode, //系统编号
          "projectno": this.$store.state.projectno, //项目编号
          "mobile": this_.forgetForm.phone, //手机号码
          "userId": this.$store.state.userId, //当前账号id
          "userName": this.$store.state.user //当前账号昵称
        };
        let paramdata = {};
        paramdata.url = '/jwt/user/sendVerificationCode';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            //获取验证码
            this_.countdown();
          } else {
            this_.countdownClickDisabled = false; //获取验证码失败，解禁获取按钮
            this_.$message.error('获取验证码失败原因:' + res.data.errmsg);
          }
        };

        paramdata.onFailed = function(res) {
          this_.countdownClickDisabled = false; //获取验证码失败，解禁获取按钮
        };

        this_.$axiosUtil.postServer(paramdata);

      },
      // 获取验证码倒计时
      countdown() {
        // if(this.countdownClickDisabled)return;
        // this.countdownClickDisabled = true;
        this.countdownTime = this.$store.state.defaultCountdownTime;
        this.verificationMsg = this.countdownTime + 's后重新获取'

        let clock = window.setInterval(() => {

          this.countdownTime--;
          this.verificationMsg = this.countdownTime + 's后重新获取';

          if (this.countdownTime < 0) {
            window.clearInterval(clock);
            this.verificationMsg = '重新获取验证码';
            this.countdownClickDisabled = false;
          }
        }, 1000);
      }
    }
  })
</script>

<style lang="scss" scoped>
  .contair {
    width: 100%;
    height: 100%;
    background: #252B3A;
  }

  .content {
    width: 1280px;
    margin: 0px auto;
    background: #252B3A;
  }

  .logoImg {
    margin: 0px auto;
    background: #252B3A;
    padding-top: 100px;
    width: 100px;
    padding-bottom: 20px;
  }

  .logoImg>img {
    background: #252B3A;
    width: 100px;
  }

  .inputContair {
    margin: 0px auto;
    padding: 20px 30px;
    /* background: #4d587359; */
    background: rgba(77, 88, 115, 0.35);
    width: 460px;
  }

  .titleText {
    color: #ffffff;
    text-align: center;
    padding-bottom: 10px;
  }

  .titleText>p:first-of-type {
    font-size: 36px;
    margin: 0px;
    line-height: 40px;
  }

  .titleText>p:last-of-type {
    font-size: 14px;
    margin: 0px;
    line-height: 20px;
  }

  .el-form-item__label {
    color: #ffffff;
  }

  >>>.el-form-item__content {
    margin-left: 30px !important;
    display: flex;
  }

  >>>.el-input__inner {
    width: 400px;
    border-radius: 0px;
    padding-left: 25px;
  }

  .verificate {
    display: flex;
  }

  .codeBox {
    width: 260px;
    margin-right: 10px;
    margin-right: 10px;
  }

  >>>.codeBox>.el-input__inner {
    width: 260px
  }

  .verification {
    height: 40px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #DCDFE6;
  }

  .verification>p {
    margin: 0px;
    line-height: 40px;
    font-size: 16px;
  }

  .agreeBox {
    color: #ffffff;
    padding-left: 30px;
  }

  .register {
    margin-top: 20px;
  }

  .message {
    text-decoration: none;
    font-size: 14px;
  }

  >>>.register .el-form-item__content {
    width: 400px;
  }

  .register button {
    width: 400px;
    background: $color-primary;
    color: #ffffff;
    border: 1px solid $color-primary;
  }

  .register button:hover {
    background: $color-primary-light-1;
  }

  .otherLogin {
    display: flex;
    color: #ffffff;
    padding: 0px 30px;
  }

  .otherLogin>p:first-of-type {
    text-align: left;
    width: 50%;
  }

  .otherLogin>p:last-of-type {
    text-align: right;
    width: 50%;
  }

  .icon-weixin {
    color: #1afa29;
    background: #ffffff;
    border-radius: 50%;
  }

  .icon-shouji,
  .icon-iconfront-,
  .icon-mima,
  .icon-nicheng {
    position: absolute;
    top: 0px;
    left: 5px;
    font-size: 16px;
    color: #CCCCCC;
    height: 40px;
    width: auto;
    line-height: 40px;
  }

  .chat,
  .loginWay>span,
  .login:hover {
    cursor: pointer;
  }

  .choiceBox {
    display: flex;
  }

  >>>.el-select {
    margin-left: 30px;
  }

  >>>.choiceBox .el-input__inner {
    width: 180px !important;
    height: 30px;
  }

  .forget {
    width: 220px;
    text-align: right;
    color: #ffffff;
  }

  .forget>span {
    margin: 0px;
    font-size: 14px;
    line-height: 30px;
  }

  .forget>span:hover {
    cursor: pointer;
  }

  >>>.el-select-dropdown__item {
    height: 25px !important;
    line-height: 25px !important;
  }

  .box {
    width: 100%;
    height: 100%;
  }

  .verificate {
    display: flex;
  }

  .codeBox {
    width: 250px;
    margin-right: 10px;
  }

  >>>.codeBox>.el-input__inner {
    width: 250px
  }

  .verificat {
    width: 140px;
    height: 40px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #DCDFE6;
  }

  .verificat>p {
    margin: 0px;
    line-height: 40px;
    font-size: 16px;
  }

  .loginWay {
    font-size: 16px;
    color: #ffffff;
    text-align: right;
    padding-right: 30px;
  }

  .tologin {
    font-size: 14px;
    color: #ffffff;
  }

  >>>.el-button {
    border-radius: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/forgetPass.vue